export interface State {}

export default {

} as State
